import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { StackDirectives } from 'src/app/shared/directives/stack-directives';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { AuthStoreService } from '../../services/auth-store.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { PasswordModule } from 'primeng/password';
import { SStorageService } from 'src/app/shared/services/sessionStorage.service';

@Component({
  selector: 'app-login-email',
  imports: [CommonModule, StackDirectives, FormsModule, ButtonModule, PasswordModule],
  templateUrl: './login-email.component.html',
  styleUrl: './login-email.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginEmailComponent {
  authStore = inject(AuthStoreService);
  sstorageService = inject(SStorageService); // Usar SStorageService para acceder a los datos de sesión
  authService = inject(AuthService);

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private loader: LoaderService
  ) {
    //Valida que en el authStore exista el usuario
    if (!this.authStore.loginData().usuario) {
      this.router.navigate(['/login']);
    }
  }

  onChangeEmail() {
    this.router.navigate(['/login']);
  }

  loginEmployee() {
    this.loader.show('Iniciando sesión...');
    const email = this.authStore.loginData().usuario;
    const password = this.authStore.loginData().password || ''; 

    this.authService.loginCompany(email, password).subscribe({
      next: (response) => {
        this.loader.hide(); // Oculta el loader al recibir la respuesta
        // console.log('Login exitoso:', response);

        if (!response.success || !response.data) {
          this.toastr.error(response.message || 'Error al iniciar sesión', 'Error');
          return;
        }

        this.handleLoginSuccess(response.data.token); // pasa el token
      },
      error: (error) => {
        this.loader.hide(); // Oculta el loader en caso de error
        if (error.status === 401) {
          // this.toastr.error(error.error?.detalle || 'No autorizado', 'Error'); Usar en caso de que las respuestas vengan del backend
            this.toastr.error('Credenciales inválidas', 'Error');
        } else {
          this.toastr.error('Error en el login', 'Error');
        }
        console.error('Error en el login:', error);
      }
    });
  }

  goBack() {
    this.authStore.clearLoginData();
    this.router.navigate(['/login']);
  }

  private handleLoginSuccess(token: string): void {
    this.loader.show('Cargando información del usuario...'); // Muestra el loader mientras se carga la información del usuario
    this.sstorageService.setItem('token', token);
    // Login por correo (empresas): no es sesión administrativa (Azure); se limpia un 'msal' viejo.
    this.sstorageService.removeItem('msal');

    this.authService.getInfoUser(token)?.subscribe({
      next: (userInfo) => {
        this.sstorageService.setItem('userInfo', JSON.stringify(userInfo.data));
        this.sstorageService.setItem('modLog', 2)
        this.router.navigate(['/app']);
      },
      error: (error) => {
        this.loader.hide(); // Oculta el loader en caso de error al obtener la información del usuario
        console.error('Error al obtener información del usuario:', error);
        this.toastr.error('Error al obtener información del usuario', 'Error');
      }
    });
  }
}
